import FJTextToImageDataConfig from '../config/dataConfig/FJTextToImageDataConfig';
import FJConfig from '../config/FJConfig';
import FJS3Config from '../config/FJS3Config';
import FJAppConstant from '../constants/FJAppConstant';
import FJConstant from '../constants/FJConstant';
import FJImageStore from '../store/FJImageStore';
import FJNetworkStore from '../store/FJNetworkStore';
import Download from '../lib/download';
import FJUtil from './FJUtil';
import FJS3NetworkManager from '../store/FJS3NetworkManager';
import FJMessageStore from '../store/FJMessageStore';
import FJLocalStore from '../store/FJLocalStore';
import FJFaceSwapConfig from '../config/appConfig/FJFaceSwapConfig';
import FJAIVideoGeneratorConfig from '../config/appConfig/FJAIVideoGeneratorConfig.js';
import FJClothesChangerConfig from '../config/appConfig/FJClothesChangerConfig.js';
import { MAX_POLLING_ERROR_TIME, TASK_POLLING_INTERVAL } from '../config/dataConfig/FJGenerateData.js';
import FJHeaderConfig from '../config/FJHeaderConfig.js';
const FJRequirementsUtil = {
    isLocalhost: function () {
        return Boolean(
            window.location.hostname === 'localhost' ||
                // [::1] is the IPv6 localhost address.
                window.location.hostname === '[::1]' ||
                // 127.0.0.1/8 is considered localhost for IPv4.
                window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/) ||
                window.location.hostname.match(/^192.168(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){2}$/),
        );
    },
    getUserId() {
        let uid;
        if (window?.fjuser?.info?.id) {
            uid = window.fjuser.info.id;
        } else {
            uid = '';
        }
        return uid;
    },
    getCurrentSpaceId: function () {
        return window.fjuser.info.current_space_id;
    },
    getCurrentSpaceType: function () {
        return window.fjuser?.info?.space_type || 'personal';
    },
    isTeamSpace: function () {
        return FJUtil.getCurrentSpaceType() === 'team';
    },
    // 是否是团队管理员
    isTeamOwner: function () {
        return this.isTeamSpace() && window.fjuser?.info?.space_permission === 'owner';
    },
    anonymousSignUp: function () {
        return new Promise((resolve, reject) => {
            try {
                window.PanelFunc.showSignUpPane();
                window.loginToCreateProjectCallback = () => {
                    resolve();
                };
            } catch (e) {
                reject(e);
            }
        });
    },
    getLanguage: function (tag, callback) {
        fetch(FJConfig.languagePath + tag + '.json?v=' + FJConfig.version)
            .then(res => res.json())
            .then(json => {
                callback(json);
            })
            .catch(err => {
                console.log(err);
            });
    },
    /**
     * @desc 添加统计
     * @param {string} eventType - 类型
     * @param {{}} eventData - 数据
     */
    eaLog(eventType, eventData = {}) {
        const data = {
            ...eventData,
            'app mode': 'ai tools',
            'app version': FJConfig.version,
            page: window.isEditPage ? 'editor' : 'tools page',
        };

        if (window.ealog && window.ealog.addEvent) {
            window.ealog.addEvent(eventType, data);
        } else {
            console.log(eventType, data);
        }
    },
    /**
     * @desc 获取积分
     * @param {*} appType （不传就从FJConfig.appType获取）
     */
    getCredits: function (appType) {
        const position = FJUtil.getToolName() + ' window';
        const aiToolName = FJUtil.getToolName(appType);
        this.eaLog('get credits click', { position, 'ai tool name': aiToolName });
        const isFreePayment = FJUtil.isFreePayment();
        // TODO 如果是编辑页内嵌版本，则使用编辑页的升级流程
        if (window.isEditPage && window.EDIT_PAGE_API && window.EDIT_PAGE_API.showUpgrade) {
            window.EDIT_PAGE_API.showUpgrade();
        } else if (window.openSubscription) {
            window.openSubscription({
                panelName: 'Credits',
                entry: aiToolName,
                showCreditRuleTable: false,
                showQuestionnaire: false,
                useNewCreditModal: true,
                useNewCreditModalABtest: isFreePayment,
            });
        }
    },
    isLogin: function () {
        return FJRequirementsUtil.isLocalhost() || (window.uid && window.uid !== -1);
    },
    login: function (loginCallback) {
        FJUtil.anonymousSignUp()
            .then(() => {
                if (loginCallback) {
                    loginCallback();
                } else {
                    FJUtil.updateLoginCreditNumber();
                }
            })
            .catch(e => console.log(e));
    },
    checkIsLogin: async function (loginCallback, errorCallback) {
        const __login = () => {
            FJUtil.anonymousSignUp()
                .then(() => {
                    if (loginCallback) {
                        loginCallback();
                    } else {
                        FJUtil.updateLoginCreditNumber();
                    }
                })
                .catch(e => console.log(e));
        };
        try {
            if (FJUtil.isLocalhost()) {
                return true;
            }
            if (!FJUtil.isLogin()) {
                __login();
                return false;
            } else {
                const isLogin = await FJNetworkStore.checkIsLogin();
                if (!isLogin) {
                    __login();
                    return false;
                }
            }
            return true;
        } catch (error) {
            if (errorCallback) {
                errorCallback();
            } else {
                FJMessageStore.addMessage(FJLocalStore._('network-error-please-try-again'), 'error');
            }
            return false;
        }
    },

    /**
     * 检查用户状态
     * @returns 0: 正常 1: 网络错误 2: 未登录 3: 切换用户 4: 个人切换团队  5:切换团队
     */
    checkUserSpace: async function (options = {}) {
        const { loginCallback, errorCallback, beforeLoginCallback, callback } = options;
        const __login = () => {
            beforeLoginCallback && beforeLoginCallback();
            FJUtil.anonymousSignUp()
                .then(() => {
                    loginCallback && loginCallback();
                    FJUtil.updateLoginCreditNumber();
                })
                .catch(e => console.log(e));
        };
        let spaceType = 1;
        try {
            if (FJUtil.isLocalhost()) {
                spaceType = 0;
            } else if (!FJUtil.isLogin()) {
                __login();
                spaceType = 2;
            } else {
                if (window.isEditPage) {
                    spaceType = 0;
                } else {
                    const spaceData = await FJNetworkStore.getSpaceData();
                    const isMobile = FJUtil.isMobile();
                    if (spaceData.uid == 0) {
                        //未登录
                        __login();
                        spaceType = 2;
                    } else if (spaceData.uid != FJUtil.getUserId()) {
                        //切换用户
                        spaceType = 3;
                    } else if (spaceData.space_type != FJUtil.getCurrentSpaceType()) {
                        //个人团队切换
                        // TODO：团队 移动端暂时不区分团队
                        spaceType = isMobile ? 0 : 4;
                    } else if (spaceData.current_space_id != FJUtil.getCurrentSpaceId()) {
                        //切换团队
                        spaceType = isMobile ? 0 : 5;
                    } else {
                        //正常
                        spaceType = 0;
                    }
                }
            }
        } catch (error) {
            if (errorCallback) {
                errorCallback();
            } else {
                FJMessageStore.addMessage(FJLocalStore._('network-error-please-try-again'), 'error');
            }
            spaceType = 1;
        }
        callback && callback(spaceType);
        return spaceType;
    },
    getTimeDiff: function (startTime, endTime) {
        if ((!startTime && startTime !== 0) || (!endTime && endTime !== 0) || startTime > endTime) {
            return;
        }
        const DIFF = 5;
        // 计算时间差（单位：毫秒）
        let timeDiff = endTime - startTime;
        // 转换为秒
        let seconds = Math.floor(timeDiff / 1000);
        // 输出或显示记时时间
        let min = Math.floor(seconds / DIFF) * DIFF;
        let max = Math.ceil(seconds / DIFF) * DIFF;
        if (min === max) {
            min -= DIFF;
        }
        return min + '-' + max;
    },
    /**
     * @desc: 更新所有位置用户积分界面
     * @param {boolean} updateFreeLimit - 是否更新免费额度(使用了免费次数需要更新)
     */
    updateAllCreditInfo: function (updateFreeLimit) {
        if (window.fj && window.fj.event && window.fj.event.dispatch) {
            window.fj.event.dispatch('UPDATE_USER_CREDITS', updateFreeLimit);
        }
    },
    parseList: async function (list, options = {}) {
        if (!list) return [];
        const {
            type,
            isUploadWaterMark = false,
            resultImageKey = FJConfig.resultImageKey,
            originalImageKey = FJConfig.originalImageKey,
            appType = FJConfig.appType,
        } = options;
        let uploadWaterMarkList = [];
        let arr = [];
        const __getResultUrl = imageName => {
            if (imageName && appType === FJAppConstant.FACE_SWAP && imageName.includes('target')) {
                return FJFaceSwapConfig.thoseTargetImagesPath + imageName;
            } else if (appType === FJAppConstant.AI_VIDEO_GENERATOR) {
                return FJS3Config.S3_SERVER_HOST + FJAIVideoGeneratorConfig.resultVideoKey + imageName;
            }
            return FJS3Config.S3_SERVER_HOST + resultImageKey + imageName;
        };
        const __getOriginalUrl = imageName => {
            if (imageName && appType === FJAppConstant.FACE_SWAP && imageName.includes('origin')) {
                return FJFaceSwapConfig.thoseOriginImagesPath + imageName;
            }
            return FJS3Config.S3_SERVER_HOST + originalImageKey + imageName;
        };

        const __getCoverUrl = (imageName, isCustomRemoveBg = true) => {
            if (appType === FJAppConstant.VIDEO_REMOVE_BG) {
                if (isCustomRemoveBg) {
                    return FJS3Config.S3_SERVER_HOST + FJConfig.resultCoverKey + imageName + '.png';
                } else {
                    return FJS3Config.S3_SERVER_HOST + FJConfig.resultCoverKey + imageName.replace('.webm', '.png');
                }
            } else if (appType === FJAppConstant.AI_VIDEO_DUB) {
                return FJS3Config.S3_SERVER_HOST + FJConfig.resultCoverKey + imageName + '.png';
            }

            return (
                FJS3Config.S3_SERVER_HOST + FJAIVideoGeneratorConfig.resultCoverKey + imageName.replace('.mp4', '.png')
            );
        };

        const __getOriginImagePathInVideo = (imageName, source) => {
            switch (source) {
                case 1:
                    return FJS3Config.S3_SERVER_HOST + FJAIVideoGeneratorConfig.originImagePath[0] + imageName;
                case 2:
                    return FJS3Config.S3_SERVER_HOST + FJAIVideoGeneratorConfig.originImagePath[1] + imageName;
                case 3:
                    return FJS3Config.S3_SERVER_HOST + FJAIVideoGeneratorConfig.originImagePath[2] + imageName;
                case 4:
                    return window.location.origin + FJAIVideoGeneratorConfig.originImagePath[3] + imageName;
                case 5: {
                    return 'https://resource.flexclip.com/pages/ai-banners/ai-image-to-video/' + imageName;
                }
            }
        };

        for (let i = 0; i < list.length; i++) {
            const item = list[i];
            let imgUrl = __getResultUrl(item.result);
            const { width, height, depth_map_info, isCustomRemoveBg, garment } = JSON.parse(item.info);
            if (item.has_watermark && isUploadWaterMark) {
                const resultUrl = FJS3Config.S3_NOT_CATCH_HOST + resultImageKey + item.result;
                const watermarkImgBlob = await FJImageStore.drawWatermarkOnPicture(resultUrl);
                const key = resultImageKey + item.result;
                uploadWaterMarkList.push({ file: watermarkImgBlob, key });
            }

            let model = item?.request_params?.model || item?.request_params?.model_type;

            if (appType === FJAppConstant.TEXT_TO_IMAGE) {
                model = FJTextToImageDataConfig.MODELS.find(item => item.value === model)?.name || model;
            }
            let obj = {
                id: item.id,
                imgUrl,
                type,
                width,
                height,
                originalUrl: __getOriginalUrl(item.original),
                createTime: item.created_at,
                hasWaterMark: item.has_watermark,
                shareKey: item.share_key,
                style: item?.style || item?.request_params?.style,
                model: model,
                ratio: item?.request_params?.ratio,
                upscaleSize: item?.request_params?.super_resolution_factor,
                textToImagePrompt: item?.request_params?.input_prompt,
                jobType: item?.job_type,
                depthMapInfo: depth_map_info,
                eventId: item.event_id,
                isCustomRemoveBg: isCustomRemoveBg,
            };
            if (appType === FJAppConstant.FAKE_3D) {
                obj.imgUrl = __getOriginalUrl(item.original);
                obj.depthMapUrl = __getResultUrl(item.result);
                depth_map_info?.originWidth && (obj.width = depth_map_info.originWidth);
                depth_map_info?.originHeight && (obj.height = depth_map_info.originHeight);
            } else if (appType === FJAppConstant.AI_VIDEO_GENERATOR) {
                const status = item?.request_params?.state;
                obj.imgUrl = status === 'completed' ? __getCoverUrl(item.result) : null;
                obj.videoUrl = status === 'completed' ? __getResultUrl(item.result) : null;
                obj.status = item?.request_params?.state;
                obj.aspectRatio = item?.request_params?.aspect_ratio;
                obj.ratio = item?.request_params?.waterfall_ratio;
                obj.generationType = item?.request_params?.generation_type;
                obj.modelType = item?.request_params?.model_type;
                obj.prompt = item?.request_params?.prompt;
                obj.duration = item?.request_params?.duration;
                obj.originalUrl = __getOriginImagePathInVideo(item.original, item?.request_params?.source);
            } else if (appType === FJAppConstant.VIDEO_REMOVE_BG) {
                obj.isCustomRemoveBg = !item?.request_params?.is_auto_remove;
                obj.videoUrl = __getResultUrl(item.result);
                obj.imgUrl = obj.isCustomRemoveBg ? __getCoverUrl(obj.eventId) : __getCoverUrl(item.result, false);
            } else if (appType === FJAppConstant.CLOTHES_CHANGER) {
                if (garment)
                    obj.garment = `${FJS3Config.S3_NOT_CATCH_HOST}${FJClothesChangerConfig.originalImageKey}${garment}`;
            } else if (appType === FJAppConstant.AI_VIDEO_DUB) {
                obj.videoUrl = __getResultUrl(item.result);
                obj.imgUrl = __getCoverUrl(obj.eventId);
                obj.prompt = item?.request_params?.input_prompt || item?.request_params?.prompt;
            }
            arr.push(obj);
        }
        if (uploadWaterMarkList.length) {
            await FJS3NetworkManager.batchUploadToS3(uploadWaterMarkList);
        }

        return arr;
    },
    createPlaceHolderList: function (options) {
        const {
            count,
            uploadImageInfo,
            selectedStyle,
            prompt,
            isUploadS3,
            uploadS3Url,
            type = FJConstant.CREATIONS,
            generateInfo,
        } = options;
        const list = [];
        for (let i = 0; i < count; i++) {
            const item = {
                id: new Date().getTime() + i,
                imgUrl: '',
                createTime: '',
                hasWaterMark: false,
                originalUrl: uploadS3Url || uploadImageInfo.src,
                width: uploadImageInfo.width,
                height: uploadImageInfo.height,
                isLoading: true,
                type,
                isReload: false,
                isUploadS3,
            };
            selectedStyle && (item.style = selectedStyle);
            generateInfo && (item.generateInfo = generateInfo);
            prompt && (item.style = prompt);
            list.push(item);
        }
        return list;
    },
    createPlaceHolderListNew: function (options) {
        const { count, width, height, type = FJConstant.CREATIONS, generateInfo } = options;
        const list = [];
        for (let i = 0; i < count; i++) {
            const item = {
                id: new Date().getTime() + i,
                imgUrl: '',
                hasWaterMark: false,
                width,
                height,
                isLoading: true,
                type,
                isReload: false,
            };
            generateInfo && (item.generateInfo = generateInfo);
            list.push(item);
        }
        return list;
    },
    getPreviewSize: function (viewSize) {
        const { width, height } = viewSize;
        const ratio = width / height;
        let w = 458;
        let h = 256;
        if (ratio > 21 / 9) {
            w = 458;
            h = 256;
        } else if (ratio >= 16 / 9) {
            w = 458;
            h = w / ratio;
        } else if (ratio >= (1 + 16 / 9) / 2) {
            h = 256;
            w = h * ratio;
        } else if (ratio >= 1) {
            w = 380;
            h = w / ratio;
        } else if (ratio > (1 + 9 / 16) / 2) {
            h = 380;
            w = h * ratio;
        } else if (ratio >= 9 / 16) {
            w = 280;
            h = w / ratio;
        } else if (ratio >= 9 / 21) {
            h = 445;
            w = h * ratio;
        } else {
            h = 445;
            w = 280;
        }
        return { width: w, height: h };
    },
    isGeneratingStatus: function (status) {
        return [FJConstant.START, FJConstant.WAITING, FJConstant.GENERATING].includes(status);
    },
    multiDownloadByUrls: async (urls, callback, options = {}) => {
        if (!urls.length) {
            callback && callback(false);
            return;
        }
        const {
            isVideo = false,
            errorMessage,
            isAudioGenerator = false,
            isWebm = false,
            downloadHistoryList = [],
        } = options;

        const _getFileName = () => {
            const now = new Date();
            // 获取年、月、日、时、分、秒
            const year = now.getFullYear();
            const month = String(now.getMonth() + 1).padStart(2, '0'); // 月份从0开始，需要加1并补零
            const day = String(now.getDate()).padStart(2, '0'); // 补零
            const hours = String(now.getHours()).padStart(2, '0'); // 补零
            const minutes = String(now.getMinutes()).padStart(2, '0'); // 补零
            const seconds = String(now.getSeconds()).padStart(2, '0'); // 补零

            // 格式化日期和时间为 2024-07-17T111525
            return `Made with FlexClip AI-${year}-${month}-${day}T${hours}${minutes}${seconds}`;
        };
        try {
            if (urls.length === 1) {
                if (isVideo) {
                    const blob = await FJUtil.downloadVideoCacheAvoidance(urls[0]);
                    if (!blob) throw new Error();
                    const name = _getFileName() + (isWebm ? '.webm' : '.mp4');
                    Download(blob, name, 'video/mp4');
                } else if (isAudioGenerator) {
                    const blob = await FJUtil.downloadVideoCacheAvoidance(urls[0]);
                    if (!blob) throw new Error();
                    const audioName = downloadHistoryList[0].audioName;
                    const isMp3 = audioName.endsWith('.mp3');
                    const name = audioName + '-' + _getFileName() + (isMp3 ? '.mp3' : '.wav');
                    Download(blob, name, isMp3 ? 'audio/mpeg' : 'audio/wav');
                } else {
                    const blob = await FJUtil.downloadImageCacheAvoidance(urls[0]);
                    if (!blob) throw new Error();
                    const name = _getFileName() + '.png';
                    Download(blob, name, 'image/png');
                }

                FJMessageStore.addMessage(FJLocalStore._('download-successfully'));
                callback && callback(true);
            } else {
                let Blobs = [];
                const folderName = _getFileName();
                for (let i = 0; i < urls.length; i++) {
                    const url = urls[i];
                    let blob;
                    if (isVideo) {
                        blob = await FJUtil.downloadVideoCacheAvoidance(url);
                        if (!blob) throw new Error();
                        blob.name = _getFileName() + i + '.mp4';
                        Blobs.push(blob);
                    } else if (isAudioGenerator) {
                        const blob = await FJUtil.downloadVideoCacheAvoidance(url);
                        if (!blob) throw new Error();
                        const isMp3 = url.endsWith('.mp3');
                        blob.name = _getFileName() + i + (isMp3 ? '.mp3' : '.wav');
                        Blobs.push(blob);
                    } else {
                        blob = await FJUtil.downloadImageCacheAvoidance(url);
                        if (!blob) throw new Error();
                        blob.name = _getFileName() + i + '.png';
                        Blobs.push(blob);
                    }
                }
                FJUtil.saveBlobsInZip(Blobs, folderName);
                FJMessageStore.addMessage(FJLocalStore._('download-successfully'));
                callback && callback(true);
            }
        } catch (e) {
            FJMessageStore.addMessage(
                errorMessage ? errorMessage : FJLocalStore._('failed-to-download-please-try-again'),
                'error',
            );
            callback && callback(false);
        }
    },
    multiDownloadByBlobs: async (blobs, callback) => {
        if (!blobs.length) {
            callback && callback(false);
            return;
        }
        const _getFileName = () => {
            const now = new Date();
            // 获取年、月、日、时、分、秒
            const year = now.getFullYear();
            const month = String(now.getMonth() + 1).padStart(2, '0'); // 月份从0开始，需要加1并补零
            const day = String(now.getDate()).padStart(2, '0'); // 补零
            const hours = String(now.getHours()).padStart(2, '0'); // 补零
            const minutes = String(now.getMinutes()).padStart(2, '0'); // 补零
            const seconds = String(now.getSeconds()).padStart(2, '0'); // 补零

            // 格式化日期和时间为 2024-07-17T111525
            return `Made with FlexClip AI-${year}-${month}-${day}T${hours}${minutes}${seconds}`;
        };
        try {
            if (blobs.length === 1) {
                const blob = blobs[0];
                if (!blob) throw new Error();
                const name = _getFileName() + '.png';
                Download(blob, name, 'image/png');
                callback && callback(true);
                FJMessageStore.addMessage(FJLocalStore._('download-successfully'));
            } else {
                let Blobs = [];
                const folderName = _getFileName();
                for (let i = 0; i < blobs.length; i++) {
                    const blob = blobs[i];
                    if (!blob) throw new Error();
                    blob.name = _getFileName() + i + '.png';
                    Blobs.push(blob);
                }
                FJUtil.saveBlobsInZip(Blobs, folderName);
                FJMessageStore.addMessage(FJLocalStore._('download-successfully'));
                callback && callback(true);
            }
        } catch (e) {
            FJMessageStore.addMessage(FJLocalStore._('failed-to-download-please-try-again'), 'error');
            callback && callback(false);
        }
    },

    updateDocumentTitle: function (appType) {
        try {
            let title = '';
            switch (appType) {
                case FJAppConstant.CLOTHES_CHANGER:
                    title = 'ai-clothes-changer';
                    break;
                case FJAppConstant.IMAGE_TO_IMAGE:
                    title = 'ai-image-to-image';
                    break;
                case FJAppConstant.IMAGE_ENHANCER:
                    title = 'ai-image-upscaler';
                    break;
                case FJAppConstant.TEXT_TO_IMAGE:
                    title = 'ai-text-to-image';
                    break;
                case FJAppConstant.PHOTO_RESTORATION:
                    title = 'ai-old-photo-restoration';
                    break;
                case FJAppConstant.PHOTO_COLORIZE:
                    title = 'ai-photo-colorizer';
                    break;
                case FJAppConstant.FACE_SWAP:
                    title = 'ai-face-swap';
                    break;
                case FJAppConstant.IMAGE_EXTENDER:
                    title = 'ai-image-extender';
                    break;
                case FJAppConstant.FAKE_3D:
                    title = '3d-photo-animation';
                    break;
                case FJAppConstant.OBJECT_ERASER:
                    title = 'ai-object-eraser';
                    break;
                case FJAppConstant.AI_VIDEO_GENERATOR:
                    title = 'ai-video-generator';
                    break;
                case FJAppConstant.PHOTO_REMOVE_BG:
                    title = 'ai-image-bg-remover';
                    break;
                case FJAppConstant.AI_AUDIO_GENERATOR:
                    title = 'ai-music-generator';
                    break;
                case FJAppConstant.VIDEO_REMOVE_BG:
                    title = 'ai-video-bg-remover';
                    break;
                case FJAppConstant.AI_VIDEO_DUB:
                    title = 'ai-video-dub';
                    break;
                case FJAppConstant.AI_TEXT_BASED_EDITING:
                    title = 'ai-text-based-editing';
                    break;
                case FJAppConstant.TEXT_TO_FULL_VIDEO:
                    title = 'ai-text-to-full-video';
                    break;
                case FJAppConstant.BLOG_URL_TO_VIDEO:
                    title = 'ai-blog-url-to-video';
                    break;
                case FJAppConstant.PRODUCT_URL_TO_VIDEO:
                    title = 'ai-product-url-to-video';
                    break;
                case FJAppConstant.PPT_TO_VIDEO:
                    title = 'ai-ppt-to-video';
                    break;

                default:
                    break;
            }
            title = FJLocalStore._(title) + ' | FlexClip';
            document.title = title;
        } catch (e) {
            console.log(e);
        }
    },
    parseModalInfoList: function (data, appType) {
        const {
            createTime,
            style,
            width,
            height,
            model,
            ratio,
            upscaleSize,
            isVideoGeneration,
            modelType,
            isCustomRemoveBg,
        } = data;
        let list = [];
        if (isVideoGeneration) {
            modelType &&
                list.push({
                    title: 'mode-desc',
                    content: FJLocalStore._(modelType === 'v1.5' ? 'professional' : modelType),
                });
        } else {
            if (appType === FJAppConstant.PHOTO_REMOVE_BG || appType === FJAppConstant.VIDEO_REMOVE_BG) {
                list.push({
                    title: 'selection-methods',
                    content: isCustomRemoveBg ? FJLocalStore._('customize-remover') : FJLocalStore._('auto-remover'),
                });
            }

            model && list.push({ title: 'model-desc', content: FJLocalStore._(model) });
            style && list.push({ title: 'style-desc', content: FJLocalStore._(style) });
            ratio && list.push({ title: 'ratio-desc', content: FJUtil.floor(ratio) });
            upscaleSize && list.push({ title: 'upscale-size-desc', content: upscaleSize + 'X' });
            width && height && list.push({ title: 'resolution-desc', content: `${width} * ${height} px` });
        }
        createTime && list.push({ title: 'date-desc', content: FJUtil.convertToCurrentTimezone(createTime) });

        return list;
    },

    getSortHistoryList: function (historyList, sortType) {
        return historyList.filter(item => {
            switch (sortType) {
                case 'all-videos':
                    return true;
                case 'text-to-video':
                    return item.generationType === 'tv';
                case 'image-to-video':
                    return item.generationType === 'iv';
                default:
            }
        });
    },
    getPaymentLevel: function () {
        return window?.fj?.currentPlan?.package;
    },
    isFreePayment: function () {
        if (FJUtil.isLocalhost()) {
            return true;
        }
        return FJUtil.getPaymentLevel() === 'free';
    },
    getToolName: function (appType = FJConfig.appType) {
        return appType.replaceAll('-', ' ');
    },

    getAudioHistoryList: function (list, index) {
        switch (index) {
            case 0:
                return list;
            case 1:
                return list.filter(item => item.audioTagType === FJConstant.AUDIO_TAG_TYPE_MUSIC);
            case 2:
                return list.filter(item => item.audioTagType === FJConstant.AUDIO_TAG_TYPE_INST);
            case 3:
                return list.filter(item => item.audioTagType === FJConstant.AUDIO_TAG_TYPE_SFX);
            default:
                return list;
        }
    },
    filterLanguageList: function (list, value, jsonValue) {
        const useValue = value.trim();
        if (useValue === '') {
            return list;
        }
        let firstArray = [];
        let array = [];
        list.forEach(item => {
            const label = FJLocalStore._(item[jsonValue || 'languageKey']);
            if (label.toLowerCase() === useValue.toLowerCase()) {
                firstArray.push(item);
            } else {
                const index = label.toLowerCase().indexOf(useValue.toLowerCase());
                if (index !== -1) {
                    if (!array[index]) {
                        array[index] = [];
                    }
                    array[index].push(item);
                }
            }
        });
        array.unshift(firstArray);
        return array.flat();
    },
    /**
     *
     * @param {*} taskIds
     * @param {*} pollingInterval
     * @returns {'event_id':out_put}
     */
    pollingTasks: function (taskIds, pollingInterval = TASK_POLLING_INTERVAL) {
        let timer = null;
        let errorTime = 0;
        let taskList = [...taskIds];
        const result = {};
        return new Promise(resolve => {
            const _error = () => {
                _complete();
                clearTimeout(timer);
                timer = null;
            };
            const _complete = () => {
                //任务结束
                resolve(result);
            };
            const _request = async () => {
                try {
                    if (taskList.length == 0) {
                        _complete();
                        return;
                    }
                    let data = await FJNetworkStore.getTaskState(taskList.join(','));
                    if (!data) {
                        errorTime++;
                        if (errorTime >= MAX_POLLING_ERROR_TIME) {
                            _error();
                        } else {
                            timer = setTimeout(_request.bind(null, taskList), pollingInterval);
                        }
                        return;
                    }
                    if (!Array.isArray(data)) {
                        // 处理数组类型的data
                        data = [data];
                    }
                    for (let i = 0; i < data.length; i++) {
                        const item = data[i];
                        const { event_id: eventId } = item;
                        switch (item.job_state) {
                            case 'succeeded':
                                if (item.out_put) {
                                    result[item.event_id] = { data: item, type: FJConstant.SUCCESS };
                                }
                                taskList = taskList.filter(i => i !== eventId);
                                break;
                            case 'waiting':
                                break;
                            case 'processing':
                                break;
                            case 'canceled':
                                result[item.event_id] = { data: item, type: FJConstant.CANCEL };
                                taskList = taskList.filter(i => i !== eventId);
                                break;
                            case 'failed':
                                result[item.event_id] = { data: item, type: FJConstant.ERROR };
                                taskList = taskList.filter(i => i !== eventId);
                                break;
                            default:
                                break;
                        }
                    }

                    timer = setTimeout(_request.bind(null), pollingInterval);
                } catch (error) {
                    _error();
                }
            };
            timer = setTimeout(_request.bind(null), pollingInterval);
        });
    },
    getTextBySlateNodes: value => {
        return value
            .map(item => {
                if (item.type === 'select') return item.value;
                else if (item.type === 'paragraph' || item.type === 'input') return item.children[0].text;
            })
            .join('');
    },
    convertToSlateNodes: data => {
        const parts = data.text.split(/(aaa|xxx)/); // 分割文本，保留分隔符
        const nodes = [];
        let optionIdx = 0;
        parts.forEach(part => {
            if (part === 'aaa') {
                nodes.push({
                    type: 'input',
                    placeholder: data.placeholder,
                    children: [{ text: '' }],
                });
            } else if (part === 'xxx') {
                nodes.push({
                    type: 'select',
                    value: data.options[optionIdx][0], // 默认选择第一个选项
                    options: data.options[optionIdx],
                    children: [{ text: '' }],
                });
                optionIdx++;
            } else if (part) {
                nodes.push({
                    type: 'paragraph',
                    children: [{ text: part }],
                });
            }
        });

        return nodes;
    },
    getAIToolHref: function (currentMenuName) {
        return FJHeaderConfig.aiMenuList.find(item => item.title === currentMenuName)?.href;
    },
    /**
     * @description 现在在进行预览时，当达到字符数限制，不会从预览句中截断，会找到最近的断句标点符号，空格作为预览结尾。（标点包括英文，中文标点 ,.，。；、……?!）
     * @param value
     * @returns {*}
     */
    getPreviewText(value) {
        const __isPunctuation = character => {
            return (
                /^[\u3000-\u303F\uFF01-\uFF20\uFF3B-\uFF40\uFFE0-\uFFE5]+$/.test(character) ||
                /^[!-\/:-@\[-`{-~]+$/.test(character)
            );
        };
        const sliceLength = 150;
        let preText = value.slice(0, sliceLength);
        if (__isPunctuation(preText.charAt(preText.length - 1))) {
            return preText;
        }

        let i = 1;
        let aCheckChar = value.slice(sliceLength, sliceLength + i);
        while (__isPunctuation(aCheckChar)) {
            i++;
            aCheckChar = value.slice(sliceLength + i - 1, sliceLength + i);
        }
        return preText;
    },
};
export default FJRequirementsUtil;
